import { AlertCircle, AlertTriangle, ShieldCheck } from 'lucide-react';
import type { ValidationResult } from './types';

interface ValidationPanelProps {
  validationResult: ValidationResult;
  loadingData: boolean;
  hasHoursEntered: boolean;
}

export function ValidationPanel({ validationResult, loadingData, hasHoursEntered }: ValidationPanelProps) {
  if (loadingData) return null;

  // Errors/warnings panel
  if (validationResult.errors.length > 0 || validationResult.warnings.length > 0) {
    return (
      <div style={{
        background: validationResult.errors.length > 0 ? '#fef2f2' : '#fffbeb',
        border: `1px solid ${validationResult.errors.length > 0 ? '#fecaca' : '#fde68a'}`,
        borderRadius: '16px',
        padding: '16px 20px',
        marginBottom: '24px'
      }}>
        {/* En-tête */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: validationResult.errors.length > 0 || validationResult.warnings.length > 0 ? '12px' : 0 }}>
          {validationResult.errors.length > 0 ? (
            <AlertCircle size={22} style={{ color: '#dc2626' }} />
          ) : (
            <AlertTriangle size={22} style={{ color: '#d97706' }} />
          )}
          <span style={{
            fontWeight: '700',
            fontSize: '1rem',
            color: validationResult.errors.length > 0 ? '#dc2626' : '#d97706'
          }}>
            {validationResult.errors.length > 0
              ? `${validationResult.errors.length} erreur${validationResult.errors.length > 1 ? 's' : ''} à corriger`
              : `${validationResult.warnings.length} avertissement${validationResult.warnings.length > 1 ? 's' : ''}`
            }
          </span>
        </div>

        {/* Liste des erreurs */}
        {validationResult.errors.length > 0 && (
          <div style={{ marginBottom: validationResult.warnings.length > 0 ? '12px' : 0 }}>
            {validationResult.errors.map((err, idx) => (
              <div key={`err-${idx}`} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '6px 0',
                color: '#b91c1c',
                fontSize: '0.9rem'
              }}>
                <span style={{ width: '6px', height: '6px', background: '#dc2626', borderRadius: '50%', flexShrink: 0 }}></span>
                {err.message}
              </div>
            ))}
          </div>
        )}

        {/* Liste des avertissements */}
        {validationResult.warnings.length > 0 && (
          <div>
            {validationResult.warnings.map((warn, idx) => (
              <div key={`warn-${idx}`} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '6px 0',
                color: '#92400e',
                fontSize: '0.9rem'
              }}>
                <span style={{ width: '6px', height: '6px', background: '#f59e0b', borderRadius: '50%', flexShrink: 0 }}></span>
                {warn.message}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // Indicateur validation OK
  if (validationResult.errors.length === 0 && validationResult.warnings.length === 0 && hasHoursEntered) {
    return (
      <div style={{
        background: '#f0fdf4',
        border: '1px solid #bbf7d0',
        borderRadius: '16px',
        padding: '12px 20px',
        marginBottom: '24px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <ShieldCheck size={22} style={{ color: '#16a34a' }} />
        <span style={{ fontWeight: '600', color: '#166534', fontSize: '0.95rem' }}>
          Feuille prête à être signée
        </span>
      </div>
    );
  }

  return null;
}
